import InputFormExtension from "@/Layouts/components/InputComponents/InputFormExtension";
import TierRowsItem from "@/Layouts/components/Tiers/TierRowsItem";
import { Stack, SxProps, Theme } from "@mui/material";
import { FC } from "react";
import {
	DOLLAR_DECIMALS,
	DOLLAR_INPUT_TYPE,
	DOLLAR_MAX,
	DOLLAR_PER_UNIT_INPUT_TYPE,
	INPUT_SX,
	PERCENT_DECIMALS,
	PERCENT_INPUT_TYPE,
	PERCENT_MAX,
} from "./constants";
import MatrixColumnCell from "./MatrixColumnCell";
import { BonusInputData, IBonus, IBonusTier, Spaces } from "./types";

interface MatrixRowProps {
	index: number;
	tier: IBonusTier;
	position?: string;
	bonusInputData?: BonusInputData[];
	spaces?: Spaces;
	rowInputErrors?: any[];
	bonusInputErrors?: any[];
	readOnly?: boolean;
	spacing?: number | string;
	cellsProps?: any;
	sxCells?: SxProps<Theme>;
	onActionUpdate: (...args: any[]) => void;
	onChangeType: (...args: any[]) => void;
}

const MatrixRow: FC<MatrixRowProps> = (props) => {
	const {
		index: rowIndex,
		tier,
		bonusInputData = [
			{
				type: DOLLAR_INPUT_TYPE,
				min: -DOLLAR_MAX,
				max: DOLLAR_MAX,
				decimals: DOLLAR_DECIMALS,
				decimalsEditable: true,
			},
			{
				type: DOLLAR_PER_UNIT_INPUT_TYPE,
				min: -DOLLAR_MAX,
				max: DOLLAR_MAX,
				decimals: DOLLAR_DECIMALS,
				decimalsEditable: true,
			},
			{
				type: PERCENT_INPUT_TYPE,
				min: -PERCENT_MAX,
				max: PERCENT_MAX,
				decimals: PERCENT_DECIMALS,
				decimalsEditable: true,
			},
		],
		spaces = {
			mainSection: 100,
			columns: 100,
			totalColumns: 1,
			totalRows: 1,
			separation: 5.5,
		},
		rowInputErrors = [],
		bonusInputErrors = [],
		readOnly = false,
		spacing = 0.8,
		cellsProps = {
			justifyContent: "center",
			alignItems: "center",
		},
		sxCells = {
			minWidth: "100px",
		},
		position,
		onActionUpdate,
		onChangeType,
	} = props;

	const handleRowUpdate = (_row: number, _column: number, _location: string, area: string, value: any) => {
		onActionUpdate(rowIndex, 0, "row", area, value);
	};

	const handleRowChangeType = (_row: number, _column: number, _location: string, area: string, input: any) => {
		onChangeType(rowIndex, 0, "row", area, input);
	};

	return (
		<TierRowsItem hasShadow={!(rowIndex % 2)} spaces={spaces}>
			<Stack direction={"row"} spacing={spacing}>
				<MatrixColumnCell
					index={rowIndex}
					item={tier as any}
					errors={rowInputErrors}
					readOnly={readOnly}
					position={position}
					onActionUpdate={handleRowUpdate}
					onChangeType={handleRowChangeType}
				/>
				<Stack direction={"row"} spacing={spacing} sx={{ paddingLeft: "60px" }}>
					{tier.bonuses?.map((element: IBonus, colIndex: number) => (
						<Stack key={`bonus_${colIndex}`} {...cellsProps} sx={sxCells}>
							<InputFormExtension
								data={bonusInputData}
								value={element?.bonus?.value || 0}
								defaultType={element?.bonus?.input || DOLLAR_INPUT_TYPE}
								error={Boolean(bonusInputErrors?.[rowIndex]?.[colIndex]?.["bonus"])}
								disabled={readOnly}
								readOnly={readOnly}
								onChangeType={(_: any, input: any) => {
									onChangeType(rowIndex, colIndex, "row", "bonus", input);
								}}
								onActionUpdate={(value: any) => {
									onActionUpdate(rowIndex, colIndex, "row", "bonus", value);
								}}
								sx={INPUT_SX}
							/>
						</Stack>
					))}
				</Stack>
			</Stack>
		</TierRowsItem>
	);
};

export default MatrixRow;
